import { motion } from "framer-motion";
import Styles from "./Backdrop.module.css";
import { connect } from "react-redux";

const Backdrop = ({ children, onClick,theme }:any) => {
  return (
    <motion.div
      onClick={onClick}
      className={Styles.backdrop}
      style={{backgroundColor:"rgba(0,0,0,0.75)"}}
    initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {children}
    </motion.div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme:state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(Backdrop);